module.exports = __webpack_public_path__ + "img/staff-honor-certificate.e422b9b8.jpg";